import api, { API_V1_MEETINGS } from "./api";

/**
 *
 * @returns
 */
export const createMeeting = async (body) => {
  return await api.post(`${API_V1_MEETINGS}/zoom`, body);
};
